module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-ru-RU.1d0b2bf7.png";